/* ===========================================================
   TURBO BJ — Ultimate LP behavior (vanilla JS)
   1) Hero Glide carousel (slide + auto + swipe + thumb sync)
   2) FAQ accordion (event delegation)
   3) #reviews-list "Load More" — clones existing card markup
   4) #testimonials Glide-style carousel — wires prev/next arrows
                                          + appends extra cards
   5) Final CTA → relabel "GET TURBO BJ"
   =========================================================== */

(function () {
  'use strict';

  // ---- Extra reviews data (loaded from reviews.json) ----
  let REVIEWS = [];
  fetch('reviews.json', { cache: 'no-store' })
    .then(r => r.json())
    .then(d => { REVIEWS = d; populateExtras(); })
    .catch(err => console.error('reviews load failed', err));

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
  let inited = false;
  function init() {
    if (inited) return; inited = true;
    initHeroCarousel();
    initFaq();
    initLoadMore();
    initTestimonialsCarousel();
    initWriteReviewModal();
    relabelFinalCta();
  }

  /* -------- 1. Hero Carousel — buy-box pattern (namespaced .hbx-*).
                  Swiper.js was killed by the cloned page's own .swiper-* CSS.
                  This uses the exact pattern that works for #cosara-buybox. -------- */
  function initHeroCarousel() {
    rebuildHeroAsBuybox();
    return;
  }

  function rebuildHeroAsBuybox() {
    const gallery = document.querySelector('.hero-gallery');
    if (!gallery) return;

    const mainImgs  = Array.from(gallery.querySelectorAll('.glide.glide-main .glide__slide img, .swiper-main .swiper-slide img'))
                         .map(img => img.currentSrc || img.src);
    const thumbImgs = Array.from(gallery.querySelectorAll('.glide.glide-thumb .glide__slide img, .swiper-thumbs .swiper-slide img'))
                         .map(img => img.currentSrc || img.src);
    if (!mainImgs.length) return;

    const slidesHTML = mainImgs.map((src, i) =>
      `<div class="hbx-slide"><img src="${src}" alt="Turbo BJ image ${i+1}" loading="${i===0?'eager':'lazy'}" decoding="async"></div>`
    ).join('');
    const thumbsHTML = (thumbImgs.length ? thumbImgs : mainImgs).map((src, i) =>
      `<button type="button" class="hbx-thumb${i===0?' is-active':''}" data-index="${i}" aria-label="Show image ${i+1}">
         <img src="${src}" alt="" loading="lazy" decoding="async">
       </button>`
    ).join('');

    gallery.innerHTML = `
      <div class="hbx-carousel" id="hbx-carousel" aria-roledescription="carousel">
        <div class="hbx-viewport">
          <div class="hbx-track">${slidesHTML}</div>
        </div>
        <button class="hbx-arrow hbx-prev" type="button" aria-label="Previous image">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M15 6l-6 6 6 6" stroke="#333" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="hbx-arrow hbx-next" type="button" aria-label="Next image">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M9 6l6 6-6 6" stroke="#333" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="hbx-dots" aria-hidden="true"></div>
      </div>
      <div class="hbx-thumbs" id="hbx-thumbs">${thumbsHTML}</div>
    `;

    const carousel = gallery.querySelector('.hbx-carousel');
    const viewport = gallery.querySelector('.hbx-viewport');
    const track    = gallery.querySelector('.hbx-track');
    const slides   = gallery.querySelectorAll('.hbx-slide');
    const prev     = gallery.querySelector('.hbx-prev');
    const next     = gallery.querySelector('.hbx-next');
    const dotsWrap = gallery.querySelector('.hbx-dots');
    const thumbs   = gallery.querySelectorAll('.hbx-thumb');
    const total    = slides.length;
    let index = 0;

    for (let i = 0; i < total; i++) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'hbx-dot' + (i === 0 ? ' is-active' : '');
      b.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(b);
    }
    const dots = dotsWrap.querySelectorAll('.hbx-dot');

    function update() {
      track.style.transform = `translateX(${-index * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
    }
    function goTo(i)  { index = (i + total) % total; update(); }
    function goPrev() { goTo(index - 1); }
    function goNext() { goTo(index + 1); }

    prev.addEventListener('click', goPrev);
    next.addEventListener('click', goNext);
    thumbs.forEach(t => t.addEventListener('click', () => goTo(parseInt(t.dataset.index, 10) || 0)));

    let sx = 0, sy = 0, dx = 0, dy = 0, dragging = false, axis = null;
    viewport.addEventListener('touchstart', e => {
      const t = e.touches[0]; sx = t.clientX; sy = t.clientY; dx = 0; dy = 0;
      dragging = true; axis = null;
    }, { passive: true });
    viewport.addEventListener('touchmove', e => {
      if (!dragging) return;
      const t = e.touches[0]; dx = t.clientX - sx; dy = t.clientY - sy;
      if (axis === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
    }, { passive: true });
    viewport.addEventListener('touchend', () => {
      if (!dragging) return;
      dragging = false;
      if (axis === 'x' && Math.abs(dx) > 40) dx < 0 ? goNext() : goPrev();
    });

    carousel.setAttribute('tabindex', '0');
    carousel.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') goPrev();
      else if (e.key === 'ArrowRight') goNext();
    });

    let timer = setInterval(goNext, 5000);
    carousel.addEventListener('mouseenter', () => { clearInterval(timer); timer = null; });
    carousel.addEventListener('mouseleave', () => { if (!timer) timer = setInterval(goNext, 5000); });

    update();
  }
  function _legacy_swiper_hero_unused() {
    const gallery = document.querySelector('.hero-gallery');
    if (!gallery) return;
    if (typeof Swiper === 'undefined') {
      // Swiper CDN hasn't loaded yet — retry shortly
      return setTimeout(rebuildHeroAsSwiper, 100);
    }

    // Gather image URLs from existing Glide markup
    const mainImgs  = Array.from(gallery.querySelectorAll('.glide.glide-main .glide__slide img'))
                         .map(img => img.currentSrc || img.src);
    const thumbImgs = Array.from(gallery.querySelectorAll('.glide.glide-thumb .glide__slide img'))
                         .map(img => img.currentSrc || img.src);
    if (!mainImgs.length) return;

    const mainSlides = mainImgs.map((src, i) =>
      `<div class="swiper-slide"><img src="${src}" alt="Turbo BJ image ${i+1}"></div>`
    ).join('');
    const thumbSlides = (thumbImgs.length ? thumbImgs : mainImgs).map((src, i) =>
      `<div class="swiper-slide"><img src="${src}" alt="Thumb ${i+1}"></div>`
    ).join('');

    gallery.innerHTML = `
      <div class="hero-swiper-wrap">
        <div class="main-wrap">
          <div class="swiper swiper-main" id="hero-swiper-main">
            <div class="swiper-wrapper">${mainSlides}</div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="thumbs-wrap">
          <div class="swiper swiper-thumbs" id="hero-swiper-thumbs">
            <div class="swiper-wrapper">${thumbSlides}</div>
          </div>
        </div>
      </div>
    `;

    let isDesktop = window.matchMedia('(min-width: 768px)').matches;
    let thumbsSwiper = new Swiper('#hero-swiper-thumbs', {
      direction: isDesktop ? 'vertical' : 'horizontal',
      slidesPerView: 5,
      spaceBetween: 8,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
    });
    const mainSwiper = new Swiper('#hero-swiper-main', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      speed: 400,
      keyboard: { enabled: true, onlyInViewport: true },
      navigation: {
        nextEl: '#hero-swiper-main .swiper-button-next',
        prevEl: '#hero-swiper-main .swiper-button-prev',
      },
      pagination: {
        el: '#hero-swiper-main .swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      },
      thumbs: { swiper: thumbsSwiper },
    });

    // Re-init thumbs direction on viewport breakpoint change
    let lastDesktop = isDesktop;
    window.addEventListener('resize', () => {
      const nowDesktop = window.matchMedia('(min-width: 768px)').matches;
      if (nowDesktop !== lastDesktop) {
        lastDesktop = nowDesktop;
        const activeIdx = mainSwiper.activeIndex;
        thumbsSwiper.destroy(true, true);
        thumbsSwiper = new Swiper('#hero-swiper-thumbs', {
          direction: nowDesktop ? 'vertical' : 'horizontal',
          slidesPerView: 5,
          spaceBetween: 8,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
        });
        mainSwiper.thumbs.swiper = thumbsSwiper;
        mainSwiper.thumbs.init();
        mainSwiper.thumbs.update(true);
        mainSwiper.slideTo(activeIdx, 0);
      }
    });
  }

  function _legacy_buybox_init_unused() {
    const gallery = document.querySelector('.hero-gallery');
    if (!gallery) return;

    // Gather image URLs from the existing Glide markup before we replace it
    const mainImgs  = Array.from(gallery.querySelectorAll('.glide.glide-main .glide__slide img'))
                         .map(img => img.currentSrc || img.src);
    const thumbImgs = Array.from(gallery.querySelectorAll('.glide.glide-thumb .glide__slide img'))
                         .map(img => img.currentSrc || img.src);
    if (!mainImgs.length) return;

    // Build new markup using the buy-box pattern (namespaced .hbx-*)
    const slidesHTML = mainImgs.map(src => `
      <div class="hbx-slide"><img src="${src}" alt="Turbo BJ product photo" loading="eager" decoding="async"></div>
    `).join('');
    const thumbsHTML = (thumbImgs.length ? thumbImgs : mainImgs).map((src, i) => `
      <button type="button" class="hbx-thumb${i === 0 ? ' is-active' : ''}" data-index="${i}" aria-label="Show image ${i+1}">
        <img src="${src}" alt="" loading="lazy" decoding="async">
      </button>
    `).join('');

    gallery.innerHTML = `
      <div class="hbx-carousel" id="hbx-carousel" aria-roledescription="carousel">
        <div class="hbx-viewport">
          <div class="hbx-track">${slidesHTML}</div>
        </div>
        <button class="hbx-arrow hbx-prev" type="button" aria-label="Previous image">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M15 6l-6 6 6 6" stroke="#333" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="hbx-arrow hbx-next" type="button" aria-label="Next image">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M9 6l6 6-6 6" stroke="#333" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="hbx-dots" aria-hidden="true"></div>
      </div>
      <div class="hbx-thumbs" id="hbx-thumbs">${thumbsHTML}</div>
    `;

    // Now wire up using the proven buy-box JS pattern
    const carousel = gallery.querySelector('.hbx-carousel');
    const viewport = gallery.querySelector('.hbx-viewport');
    const track    = gallery.querySelector('.hbx-track');
    const slides   = gallery.querySelectorAll('.hbx-slide');
    const prev     = gallery.querySelector('.hbx-prev');
    const next     = gallery.querySelector('.hbx-next');
    const dotsWrap = gallery.querySelector('.hbx-dots');
    const thumbs   = gallery.querySelectorAll('.hbx-thumb');
    const total    = slides.length;
    let index = 0;

    // Build dots
    for (let i = 0; i < total; i++) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'hbx-dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Go to image ' + (i + 1));
      b.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(b);
    }
    const dots = dotsWrap.querySelectorAll('.hbx-dot');

    function update() {
      track.style.transform = `translateX(${-index * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
    }
    function goTo(i)   { index = (i + total) % total; update(); }
    function goPrev()  { goTo(index - 1); }
    function goNext()  { goTo(index + 1); }

    prev.addEventListener('click', goPrev);
    next.addEventListener('click', goNext);
    thumbs.forEach(t => t.addEventListener('click', () => goTo(parseInt(t.dataset.index, 10) || 0)));

    // Touch swipe
    let startX = 0, startY = 0, deltaX = 0, deltaY = 0, dragging = false, axis = null;
    viewport.addEventListener('touchstart', e => {
      const t = e.touches[0];
      startX = t.clientX; startY = t.clientY; deltaX = 0; deltaY = 0;
      dragging = true; axis = null;
    }, { passive: true });
    viewport.addEventListener('touchmove', e => {
      if (!dragging) return;
      const t = e.touches[0];
      deltaX = t.clientX - startX; deltaY = t.clientY - startY;
      if (axis === null && (Math.abs(deltaX) > 8 || Math.abs(deltaY) > 8)) {
        axis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
      }
    }, { passive: true });
    viewport.addEventListener('touchend', () => {
      if (!dragging) return;
      dragging = false;
      if (axis === 'x' && Math.abs(deltaX) > 40) deltaX < 0 ? goNext() : goPrev();
    });

    // Keyboard
    carousel.setAttribute('tabindex', '0');
    carousel.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') goPrev();
      else if (e.key === 'ArrowRight') goNext();
    });

    // Auto-rotate (5s, pause on hover)
    let timer = setInterval(() => goNext(), 5000);
    carousel.addEventListener('mouseenter', () => { clearInterval(timer); timer = null; });
    carousel.addEventListener('mouseleave', () => { if (!timer) timer = setInterval(() => goNext(), 5000); });

    update();
  }
  function _legacy_initHeroCarousel_unused() {
    const main = document.querySelector('.hero-gallery .glide.glide-main');
    if (!main) return;

    const trackBox = main.querySelector('.glide__track');
    const track  = main.querySelector('.glide__slides');
    const slides = main.querySelectorAll('.glide__slide');
    const thumbs = document.querySelectorAll('.hero-gallery .glide.glide-thumb .glide__slide');
    const prev   = main.querySelector('.glide__arrow--left');
    const next   = main.querySelector('.glide__arrow--right');
    if (!track || !slides.length) return;

    // Aggressively reset any Glide-leftover inline state on the entire subtree
    if (trackBox) trackBox.removeAttribute('style');
    track.removeAttribute('style');
    track.style.transform = 'translate3d(0, 0, 0)';
    track.style.transition = 'transform 0.4s cubic-bezier(0.22, 0.61, 0.36, 1)';
    slides.forEach(s => {
      s.removeAttribute('style');
      // Force picture + img to fill the slide explicitly via inline style
      const pic = s.querySelector('picture');
      if (pic) {
        pic.style.cssText = 'display:block;width:100%;height:100%;';
      }
      const img = s.querySelector('img');
      if (img) {
        img.style.cssText = 'display:block;width:100%;height:100%;object-fit:cover;border-radius:0;pointer-events:none;';
      }
    });

    thumbs.forEach((t, i) => t.classList.toggle('active', i === 0));

    const dotsEl = document.createElement('div');
    dotsEl.className = 'progress';
    dotsEl.innerHTML = Array.from(slides).map(() => '<span></span>').join('');
    main.appendChild(dotsEl);
    const dots = dotsEl.querySelectorAll('span');

    let i = 0;
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = `translate3d(${-i * 100}%, 0, 0)`;
      thumbs.forEach((t, idx) => t.classList.toggle('active', idx === i));
      dots.forEach((d, idx) => d.classList.toggle('active', idx === i));
    }
    go(0);

    prev && prev.addEventListener('click', () => { go(i - 1); restartAuto(); });
    next && next.addEventListener('click', () => { go(i + 1); restartAuto(); });
    thumbs.forEach((t, idx) => t.addEventListener('click', () => { go(idx); restartAuto(); }));

    main.tabIndex = 0;
    main.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft')  { go(i - 1); restartAuto(); }
      if (e.key === 'ArrowRight') { go(i + 1); restartAuto(); }
    });

    let timer = null;
    function startAuto() { timer = setInterval(() => go(i + 1), 5000); }
    function stopAuto() { clearInterval(timer); timer = null; }
    function restartAuto() { stopAuto(); startAuto(); }
    main.addEventListener('mouseenter', stopAuto);
    main.addEventListener('mouseleave', startAuto);
    startAuto();

    let startX = null, dx = 0;
    track.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX; dx = 0;
      track.style.transition = 'none';
      stopAuto();
    }, { passive: true });
    track.addEventListener('touchmove', e => {
      if (startX === null) return;
      dx = e.touches[0].clientX - startX;
      const pct = (dx / main.offsetWidth) * 100;
      track.style.transform = `translate3d(calc(${-i * 100}% + ${pct}%), 0, 0)`;
    }, { passive: true });
    track.addEventListener('touchend', () => {
      track.style.transition = '';
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); else go(i);
      startX = null; dx = 0;
      startAuto();
    });
  }

  /* -------- 2. FAQ Accordion — uses the original page's mechanism
                  (`.questions__cardList-open` class on inner list + height) -------- */
  document.addEventListener('click', e => {
    const card = e.target.closest('#faq .questions__card');
    if (!card) return;
    if (e.target.closest('a')) return;
    e.preventDefault();
    const list = card.querySelector('.questions__cardList');
    const wrap = card.querySelector('.questions__listWrap');
    if (!list || !wrap) return;
    const isOpen = list.classList.contains('questions__cardList-open');
    // Close everything first (one-open-at-a-time)
    document.querySelectorAll('#faq .questions__cardList').forEach(l => {
      l.classList.remove('questions__cardList-open');
    });
    document.querySelectorAll('#faq .questions__listWrap').forEach(w => {
      w.style.height = '0';
    });
    document.querySelectorAll('#faq .questions__card').forEach(c => {
      c.setAttribute('expanded', 'false');
    });
    // Open this one
    if (!isOpen) {
      list.classList.add('questions__cardList-open');
      wrap.style.height = list.scrollHeight + 24 + 'px';
      card.setAttribute('expanded', 'true');
    }
  });
  function initFaq() {
    document.querySelectorAll('#faq .questions__card').forEach(c => {
      if (!c.hasAttribute('expanded')) c.setAttribute('expanded', 'false');
    });
    document.querySelectorAll('#faq .questions__listWrap').forEach(w => {
      w.style.height = '0';
    });
  }

  /* -------- 3. Reviews-list "Load More" — clone existing card template -------- */
  function initLoadMore() {
    const btn = document.getElementById('read-more');
    if (!btn) return;
    btn.addEventListener('click', () => populateExtras(true));
  }
  function populateExtras(forceShowAll) {
    if (!REVIEWS.length) return;

    // (a) #reviews-list — DO NOT append on initial load (keeps page identical to so-tight-sale).
    //     Only on Load More click do we append the 24 new reviews behind the existing 8.
    const listContainer = document.querySelector('#reviews-list .reviews__list');
    const tmplCard = listContainer && listContainer.querySelector('.review-card');
    if (listContainer && tmplCard && forceShowAll && !listContainer.dataset.tbExtended) {
      REVIEWS.forEach(r => listContainer.appendChild(buildReviewCard(tmplCard, r)));
      listContainer.dataset.tbExtended = '1';
      const btn = document.getElementById('read-more');
      if (btn) btn.style.display = 'none';
    }

    // (b) #testimonials — append all 24 new ones to the carousel so left/right scroll gets more content
    const tslides = document.querySelector('#testimonials .glide__slides');
    const tTmpl = tslides && tslides.querySelector('.glide__slide');
    if (tslides && tTmpl && !tslides.dataset.tbExtended) {
      tslides.style.width = '';
      tslides.style.transform = '';
      tslides.style.transition = '';
      REVIEWS.forEach(r => tslides.appendChild(buildTestimonialCard(tTmpl, r)));
      tslides.dataset.tbExtended = '1';
    }
  }

  function buildReviewCard(tmpl, r) {
    const node = tmpl.cloneNode(true);
    // Unique avatar — local NB2-generated portrait. If the file isn't there yet
    // (batch still running), fall back to randomuser.me by seed so the slot isn't blank.
    const slug = r.name.toLowerCase().replace(/\./g, '').replace(/\s+/g, '-');
    const primaryAvatar = `avatars/avatar-${slug}.png`;
    const fallback = `https://randomuser.me/api/portraits/men/${Math.abs(hashString(r.name)) % 99 + 1}.jpg`;
    const avatarImg = node.querySelector('.review-avatar__image img');
    if (avatarImg) {
      avatarImg.src = primaryAvatar;
      avatarImg.onerror = function () {
        this.onerror = null;
        this.src = fallback;
      };
      avatarImg.removeAttribute('data-original-src');
      avatarImg.removeAttribute('srcset');
    }
    // Name
    const nameEl = node.querySelector('.review-avatar__name .review-text--primary');
    if (nameEl) nameEl.textContent = r.name;
    // Days ago text
    const daysEls = node.querySelectorAll('.review-text--secondary');
    // Title (h3)
    const titleEl = node.querySelector('.review-card__review .review-text--primary');
    if (titleEl) titleEl.textContent = r.title;
    // Body (p)
    const bodyEl = node.querySelector('.review-card__description');
    if (bodyEl) bodyEl.textContent = `${r.body} — ${r.name}, ${r.location.split(',')[0]}`;
    // Days-ago (top + side)
    const days = relativeDays(r.date);
    node.querySelectorAll('.review-days-ago, .review-score--mobile .review-text--secondary').forEach(el => {
      el.textContent = days;
    });
    // Star rating — keep using the page's actual star-5 SVG asset, just clip a
    // bottom "grey" layer with the gold layer on top sized to the rating width.
    // Looks pixel-identical to the original cards.
    node.querySelectorAll('img[src*="star-"]').forEach(img => {
      const orig = img.getAttribute('src');
      const w = img.getAttribute('width')  || '96';
      const h = img.getAttribute('height') || '18';
      const pct = Math.max(0, Math.min(1, (r.stars || 5) / 5));
      const wrap = document.createElement('span');
      wrap.style.cssText = `position:relative;display:inline-block;width:${w}px;height:${h}px;vertical-align:middle;`;
      wrap.innerHTML = `
        <img src="${orig}" width="${w}" height="${h}" style="display:block;width:100%;height:100%;filter:grayscale(1) brightness(1.5) opacity(0.55);" alt="">
        <img src="${orig}" width="${w}" height="${h}" style="position:absolute;left:0;top:0;height:100%;width:${pct * 100}%;object-fit:cover;object-position:left center;" alt="${(r.stars || 5)} stars">
      `;
      // copy any margin from original img
      if (img.style.cssText) wrap.style.cssText += ';' + img.style.cssText;
      img.replaceWith(wrap);
    });
    // Like counter — 0–15 max, deterministic per review name so it stays stable across reloads
    const counterEl = node.querySelector('.review-likes__thumb .review-text--counter');
    if (counterEl) {
      counterEl.textContent = String(Math.abs(hashString(r.name + 'likes')) % 16);
    }
    // 30% of cards get a UGC product image slot — slug-named, user provides files later.
    // If the file isn't there yet, the slot is hidden so we don't show broken images.
    const imagesUl = node.querySelector('.review-card__images');
    if (imagesUl) {
      const shouldShowUgc = Math.abs(hashString(r.name + 'ugc')) % 10 < 3; // ~30%
      if (shouldShowUgc) {
        const slug = r.name.toLowerCase().replace(/\./g, '').replace(/\s+/g, '-');
        const ugcImg = imagesUl.querySelector('img');
        if (ugcImg) {
          // Cascade: png → webp → jpg → remove slot if none exist
          ugcImg.src = `ugc/ugc-${slug}.png`;
          ugcImg.removeAttribute('data-original-src');
          ugcImg.removeAttribute('srcset');
          ugcImg.onerror = function () {
            this.onerror = function () {
              this.onerror = function () { imagesUl.remove(); };
              this.src = `ugc/ugc-${slug}.jpg`;
            };
            this.src = `ugc/ugc-${slug}.webp`;
          };
        }
      } else {
        imagesUl.remove();
      }
    }
    return node;
  }

  function buildTestimonialCard(tmpl, r) {
    const node = tmpl.cloneNode(true);
    // Remove the --clone modifier if present (existing slides have it from Glide)
    node.classList.remove('glide__slide--clone');
    // Title
    const titleEl = node.querySelector('.testimonial-text--heading');
    if (titleEl) titleEl.textContent = r.title;
    // Body
    const bodyEl = node.querySelector('.testimonial-text--description p, .testimonial-text--description');
    if (bodyEl) bodyEl.textContent = r.body;
    // Name
    const nameEl = node.querySelector('.testimonial-text--userName');
    if (nameEl) nameEl.textContent = `${r.name} — ${r.location.split(',')[0]}`;
    // Preserve inline width/margin from the template (visual consistency)
    return node;
  }

  /* ------ Star rendering helpers (supports half-stars) ------ */
  function renderStarsSvg(rating, opts = {}) {
    const size = opts.size || 18;
    const color = opts.color || '#D1A748';
    const empty = opts.empty || '#E5E5E5';
    const full = Math.floor(rating);
    const hasHalf = (rating - full) >= 0.25 && (rating - full) < 0.75;
    const wholeFull = (rating - full) >= 0.75 ? full + 1 : full;
    let html = '';
    for (let i = 1; i <= 5; i++) {
      const isFull = i <= wholeFull;
      const isHalf = !isFull && i === full + 1 && hasHalf;
      if (isHalf) {
        const id = 'half' + Math.random().toString(36).slice(2, 8);
        html += `<svg width="${size}" height="${size}" viewBox="0 0 24 24" style="display:inline-block;vertical-align:middle">
          <defs><linearGradient id="${id}"><stop offset="50%" stop-color="${color}"/><stop offset="50%" stop-color="${empty}"/></linearGradient></defs>
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="url(#${id})"/>
        </svg>`;
      } else {
        html += `<svg width="${size}" height="${size}" viewBox="0 0 24 24" style="display:inline-block;vertical-align:middle"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="${isFull ? color : empty}"/></svg>`;
      }
    }
    return html;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({
      '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
    }[c]));
  }

  function hashString(s) {
    let h = 0;
    for (let i = 0; i < s.length; i++) {
      h = ((h << 5) - h) + s.charCodeAt(i);
      h |= 0;
    }
    return h;
  }

  function relativeDays(dateStr) {
    const d = new Date(dateStr);
    if (isNaN(d)) return '2 days ago';
    const days = Math.max(1, Math.round((Date.now() - d.getTime()) / 86400000));
    if (days < 7)  return `${days} day${days === 1 ? '' : 's'} ago`;
    if (days < 30) return `${Math.round(days / 7)} week${days < 14 ? '' : 's'} ago`;
    return `${Math.round(days / 30)} month${days < 60 ? '' : 's'} ago`;
  }

  /* -------- 4. Testimonials carousel — V2 transform slider (chosen by user)
                  Completely replaces the broken Glide markup with our own.
                  Uses translateX, indicator dots, drag, swipe. -------- */
  function initTestimonialsCarousel() {
    const oldSection = document.getElementById('testimonials');
    if (!oldSection) return;

    // Wait for reviews to load
    if (!REVIEWS.length) {
      return setTimeout(initTestimonialsCarousel, 100);
    }

    // Capture original 28 testimonial entries before we nuke the section
    const orig = Array.from(oldSection.querySelectorAll('.testimonial-card')).map(card => {
      const heading = card.querySelector('.testimonial-text--heading');
      const body = card.querySelector('.testimonial-text--description');
      const name = card.querySelector('.testimonial-text--userName');
      return {
        title: heading ? heading.textContent.trim() : '',
        body:  body ? body.textContent.trim() : '',
        name:  name ? name.textContent.trim() : '',
        date:  '',
        stars: 5,
        location: ''
      };
    }).filter(r => r.title || r.body);

    // Combine: my 24 new reviews + original 28 = 52 testimonials
    const allReviews = [...REVIEWS, ...orig];

    // Replace section markup with V2 structure
    const heading = oldSection.querySelector('.section-title--heading');
    const subhead = oldSection.querySelector('.section-title--subheading');
    const headingText = heading ? heading.textContent : 'More Happy Customers';
    const subText = subhead ? subhead.textContent : 'See what our customers are saying!';

    oldSection.innerHTML = `
      <div class="section-title">
        <h3 class="section-title--heading">${escapeHtml(headingText)}</h3>
        <h4 class="section-title--subheading">${escapeHtml(subText)}</h4>
        <div class="section-title--divider"></div>
      </div>
      <div class="tb-tcarousel-wrap">
        <div class="tb-tcarousel" id="tb-tcarousel">
          <button class="tb-tcarousel-arrow tb-tprev" type="button" aria-label="Previous review">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          </button>
          <div class="tb-tviewport">
            <div class="tb-ttrack"></div>
          </div>
          <button class="tb-tcarousel-arrow tb-tnext" type="button" aria-label="Next review">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
          </button>
        </div>
        <div class="tb-tdots"></div>
      </div>
    `;

    const track = oldSection.querySelector('.tb-ttrack');
    const viewport = oldSection.querySelector('.tb-tviewport');
    const prevBtn = oldSection.querySelector('.tb-tprev');
    const nextBtn = oldSection.querySelector('.tb-tnext');
    const dotsContainer = oldSection.querySelector('.tb-tdots');

    let currentIndex = 0;
    let cardStep = 336;
    let dragStartX = 0;
    let dragDelta = 0;
    let isDragging = false;

    // V2 testimonial cards use Trustpilot-style green-block stars with half support.
    function tbTrustStars(rating) {
      const full = Math.floor(rating);
      const hasHalf = (rating - full) >= 0.25 && (rating - full) < 0.75;
      const wholeFull = (rating - full) >= 0.75 ? full + 1 : full;
      let html = '';
      for (let i = 1; i <= 5; i++) {
        const isFull = i <= wholeFull;
        const isHalf = !isFull && i === full + 1 && hasHalf;
        if (isHalf) {
          html += `<span class="tb-tstar tb-tstar-half"><span class="tb-tstar-fill"></span><svg viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg></span>`;
        } else {
          html += `<span class="tb-tstar${isFull ? '' : ' tb-tstar-empty'}"><svg viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg></span>`;
        }
      }
      return html;
    }

    track.innerHTML = allReviews.map(r => {
      const stars = tbTrustStars(r.stars || 5);
      const dateStr = r.date || '';
      return `
        <div class="tb-tcard">
          <div class="tb-tstars">${stars}</div>
          <div class="tb-ttitle">${escapeHtml(r.title)}</div>
          <div class="tb-tbody">${escapeHtml(r.body)}</div>
          <div class="tb-tmeta">
            <strong>${escapeHtml(r.name)}</strong>
            ${dateStr ? `<span>${escapeHtml(dateStr)}</span>` : '<span>Verified customer</span>'}
          </div>
        </div>
      `;
    }).join('');

    function computeCardStep() {
      const card = track.querySelector('.tb-tcard');
      if (!card) return;
      const rect = card.getBoundingClientRect();
      const style = window.getComputedStyle(card);
      cardStep = rect.width + (parseFloat(style.marginRight) || 0);
    }
    function applyTransform(extra = 0) {
      const x = -(currentIndex * cardStep) + extra;
      track.style.transform = `translate3d(${x}px, 0, 0)`;
    }
    function maxIndex() { return Math.max(0, allReviews.length - 1); }
    function goTo(i) {
      const max = maxIndex();
      if (i < 0) currentIndex = max;
      else if (i > max) currentIndex = 0;
      else currentIndex = i;
      applyTransform();
      updateDots();
    }
    function next() { goTo(currentIndex + 1); }
    function prev() { goTo(currentIndex - 1); }

    // Dots — capped at 8 (group dots). Each dot jumps to a proportional position.
    const DOT_COUNT = Math.min(8, allReviews.length);
    dotsContainer.innerHTML = '';
    for (let i = 0; i < DOT_COUNT; i++) {
      const btn = document.createElement('button');
      btn.className = 'tb-tdot' + (i === 0 ? ' active' : '');
      btn.setAttribute('aria-label', `Go to group ${i + 1}`);
      btn.addEventListener('click', () => {
        const target = Math.round((i / (DOT_COUNT - 1)) * (allReviews.length - 1));
        goTo(target);
      });
      dotsContainer.appendChild(btn);
    }
    function updateDots() {
      const ratio = allReviews.length > 1 ? currentIndex / (allReviews.length - 1) : 0;
      const activeDot = Math.round(ratio * (DOT_COUNT - 1));
      [...dotsContainer.children].forEach((el, i) =>
        el.classList.toggle('active', i === activeDot)
      );
    }

    prevBtn.addEventListener('click', prev);
    nextBtn.addEventListener('click', next);

    function pointerDown(e) {
      isDragging = true;
      dragDelta = 0;
      dragStartX = e.touches ? e.touches[0].clientX : e.clientX;
      track.classList.add('dragging');
    }
    function pointerMove(e) {
      if (!isDragging) return;
      const x = e.touches ? e.touches[0].clientX : e.clientX;
      dragDelta = x - dragStartX;
      applyTransform(dragDelta);
    }
    function pointerUp() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('dragging');
      const threshold = Math.min(80, cardStep * 0.25);
      if (Math.abs(dragDelta) > threshold) {
        dragDelta < 0 ? next() : prev();
      } else {
        applyTransform();
      }
      dragDelta = 0;
    }
    track.addEventListener('mousedown', e => { e.preventDefault(); pointerDown(e); });
    window.addEventListener('mousemove', pointerMove);
    window.addEventListener('mouseup', pointerUp);
    track.addEventListener('touchstart', pointerDown, { passive: true });
    track.addEventListener('touchmove', pointerMove, { passive: true });
    track.addEventListener('touchend', pointerUp);
    track.addEventListener('touchcancel', pointerUp);
    track.addEventListener('click', e => {
      if (Math.abs(dragDelta) > 4) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    window.addEventListener('resize', () => { computeCardStep(); applyTransform(); });
    requestAnimationFrame(() => { computeCardStep(); applyTransform(); });
  }
  function _legacy_testimonials_unused() {
    const wrap = document.getElementById('testimonials-glide');
    if (!wrap) return;
    const track = wrap.querySelector('.glide__track');
    const slides = wrap.querySelector('.glide__slides');
    if (!track || !slides) return;

    // Force the track into a native horizontal scroller, blow away all Glide cached state
    track.setAttribute('data-tb-scroller', '1');
    track.style.cssText  = 'overflow-x:scroll!important;overflow-y:hidden!important;scroll-snap-type:x mandatory;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;cursor:grab;width:100%;padding-bottom:12px;';
    slides.style.cssText = 'transform:none!important;transition:none!important;width:max-content!important;display:flex!important;flex-direction:row!important;gap:8px;list-style:none;padding:0;margin:0;';

    function alignSlides() {
      slides.querySelectorAll('.glide__slide').forEach(s => {
        s.style.scrollSnapAlign = 'start';
        s.style.flexShrink = '0';
        s.style.transform = 'none';
      });
    }
    alignSlides();
    new MutationObserver(alignSlides).observe(slides, { childList: true });

    // Ensure parents don't clip the scroll
    const testParent = wrap.closest('.testimonials');
    if (testParent) testParent.style.overflow = 'visible';
    const section = wrap.closest('#testimonials');
    if (section) section.style.overflow = 'visible';

    // mouse drag scroll
    let down = false, startX = 0, startScroll = 0;
    track.addEventListener('mousedown', e => {
      down = true; startX = e.pageX; startScroll = track.scrollLeft;
      track.style.cursor = 'grabbing';
      track.style.scrollBehavior = 'auto';
    });
    ['mouseup', 'mouseleave'].forEach(ev => track.addEventListener(ev, () => {
      if (!down) return;
      down = false;
      track.style.cursor = 'grab';
      track.style.scrollBehavior = 'smooth';
    }));
    track.addEventListener('mousemove', e => {
      if (!down) return;
      e.preventDefault();
      track.scrollLeft = startScroll - (e.pageX - startX) * 1.4;
    });
  }

  // Event-delegated arrow handlers — survive any timing race with other scripts.
  document.addEventListener('click', e => {
    const isPrev = e.target.closest('#testimonial-prev');
    const isNext = e.target.closest('#testimonial-next');
    if (!isPrev && !isNext) return;
    e.preventDefault();
    e.stopPropagation();
    const track = document.querySelector('[data-tb-scroller]')
              || document.querySelector('#testimonials-glide .glide__track');
    if (!track) return;
    const first = track.querySelector('.glide__slide');
    const w = first ? first.offsetWidth + 16 : 336;
    const dir = isPrev ? -1 : 1;
    const newLeft = track.scrollLeft + dir * w * 2;
    // Try smooth, then snap if no change
    const before = track.scrollLeft;
    track.scrollTo({ left: newLeft, behavior: 'smooth' });
    setTimeout(() => {
      if (track.scrollLeft === before) track.scrollLeft = newLeft;
    }, 80);
  }, true); // capture phase — fires BEFORE any other click handler can preventDefault

  /* -------- 4b. Write-a-review modal — V1 centered card with red circular X (chosen by user) -------- */
  function initWriteReviewModal() {
    const trigger = document.getElementById('form-modal');
    if (!trigger) return;

    // Hide / discard the cloned-site's broken modal
    const oldModal = document.getElementById('modal-container');
    if (oldModal) oldModal.style.display = 'none';

    // Inject a fresh V1 modal at the end of <body>
    if (!document.getElementById('tb-review-backdrop')) {
      const wrap = document.createElement('div');
      wrap.innerHTML = `
        <div class="tb-review-backdrop" id="tb-review-backdrop" aria-hidden="true">
          <div class="tb-review-modal" role="dialog" aria-modal="true" aria-labelledby="tb-review-title">
            <button class="tb-review-close" id="tb-review-close" aria-label="Close" title="Close">
              <svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <line x1="6" y1="6" x2="18" y2="18"></line>
                <line x1="18" y1="6" x2="6" y2="18"></line>
              </svg>
            </button>
            <div class="tb-review-form-wrap" id="tb-review-form-wrap">
              <div class="tb-review-header">
                <h3 id="tb-review-title">Share your experience</h3>
                <p>Tell us how it was — your review helps other guys decide.</p>
              </div>
              <form id="tb-review-form" novalidate>
                <div class="tb-review-field" id="tb-rf-rating">
                  <label>Your rating</label>
                  <div class="tb-review-stars" id="tb-review-stars" role="radiogroup" aria-label="Star rating">
                    ${[1,2,3,4,5].map(v => `
                      <button type="button" class="tb-rstar" data-value="${v}" aria-label="${v} star${v>1?'s':''}">
                        <svg viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                      </button>
                    `).join('')}
                  </div>
                  <div class="tb-review-error">Please select at least 1 star.</div>
                </div>
                <div class="tb-review-field" id="tb-rf-name">
                  <label for="tb-rn-name">Name</label>
                  <input type="text" id="tb-rn-name" placeholder="Your name" autocomplete="name">
                  <div class="tb-review-error">Please enter your name.</div>
                </div>
                <div class="tb-review-field" id="tb-rf-email">
                  <label for="tb-rn-email">Email</label>
                  <input type="email" id="tb-rn-email" placeholder="you@example.com" autocomplete="email">
                  <div class="tb-review-hint">We won't publish your email — it stays private.</div>
                  <div class="tb-review-error">Please enter a valid email address.</div>
                </div>
                <div class="tb-review-field" id="tb-rf-title">
                  <label for="tb-rn-title">Title</label>
                  <input type="text" id="tb-rn-title" placeholder="Sum it up in a few words">
                  <div class="tb-review-error">Please add a short title.</div>
                </div>
                <div class="tb-review-field" id="tb-rf-comment">
                  <label for="tb-rn-comment">Your review</label>
                  <textarea id="tb-rn-comment" rows="4" placeholder="What did you think? Be honest."></textarea>
                  <div class="tb-review-error">Please write a few words about your experience.</div>
                </div>
                <button type="submit" class="tb-review-submit">POST REVIEW</button>
              </form>
            </div>
            <div class="tb-review-success" id="tb-review-success">
              <div class="tb-review-check">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <h4>Thanks!</h4>
              <p>Your review will appear shortly.</p>
            </div>
          </div>
        </div>
      `;
      document.body.appendChild(wrap.firstElementChild);
    }

    const backdrop   = document.getElementById('tb-review-backdrop');
    const closeBtn   = document.getElementById('tb-review-close');
    const form       = document.getElementById('tb-review-form');
    const formWrap   = document.getElementById('tb-review-form-wrap');
    const successEl  = document.getElementById('tb-review-success');
    const starsWrap  = document.getElementById('tb-review-stars');
    const stars      = starsWrap.querySelectorAll('.tb-rstar');
    let chosenStars  = 0;
    let closeTimer   = null;

    function open() {
      backdrop.classList.add('open');
      backdrop.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      backdrop.classList.remove('open');
      backdrop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      setTimeout(() => {
        formWrap.classList.remove('hide');
        successEl.classList.remove('show');
        form.reset();
        chosenStars = 0;
        paintStars(0);
        document.querySelectorAll('.tb-review-field.invalid').forEach(f => f.classList.remove('invalid'));
      }, 250);
    }
    function paintStars(v) {
      stars.forEach(b => {
        const sv = parseInt(b.dataset.value, 10);
        b.classList.toggle('active', sv <= v);
        b.classList.remove('hover');
      });
    }
    function previewStars(v) {
      stars.forEach(b => {
        const sv = parseInt(b.dataset.value, 10);
        b.classList.toggle('hover', sv <= v);
      });
    }
    stars.forEach(btn => {
      btn.addEventListener('mouseenter', () => previewStars(parseInt(btn.dataset.value, 10)));
      btn.addEventListener('mouseleave', () => stars.forEach(b => b.classList.remove('hover')));
      btn.addEventListener('click', () => {
        chosenStars = parseInt(btn.dataset.value, 10);
        paintStars(chosenStars);
        document.getElementById('tb-rf-rating').classList.remove('invalid');
      });
    });

    trigger.addEventListener('click', e => { e.preventDefault(); open(); });
    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', e => { if (e.target === backdrop) close(); });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && backdrop.classList.contains('open')) close();
    });

    form.addEventListener('submit', e => {
      e.preventDefault();
      let valid = true;
      const ratingF = document.getElementById('tb-rf-rating');
      const nameF   = document.getElementById('tb-rf-name');
      const emailF  = document.getElementById('tb-rf-email');
      const titleF  = document.getElementById('tb-rf-title');
      const commentF = document.getElementById('tb-rf-comment');
      const nameV   = document.getElementById('tb-rn-name').value.trim();
      const emailV  = document.getElementById('tb-rn-email').value.trim();
      const titleV  = document.getElementById('tb-rn-title').value.trim();
      const commentV = document.getElementById('tb-rn-comment').value.trim();

      const setInvalid = (el, cond) => { el.classList.toggle('invalid', cond); if (cond) valid = false; };
      setInvalid(ratingF, chosenStars < 1);
      setInvalid(nameF,   !nameV);
      setInvalid(emailF,  !emailV || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailV));
      setInvalid(titleF,  !titleV);
      setInvalid(commentF, !commentV);
      if (!valid) return;

      // Just show a confirmation — we don't actually post the review to the visible
      // list. It's "submitted for review" and would be moderated server-side.
      // (Also means the test review doesn't persist on reload.)
      const successCopy = successEl.querySelector('h4');
      const successDesc = successEl.querySelector('p');
      if (successCopy) successCopy.textContent = 'Thanks!';
      if (successDesc) successDesc.textContent = 'Your review has been submitted for review. Once approved, it\'ll appear on the page.';
      formWrap.classList.add('hide');
      successEl.classList.add('show');
      closeTimer = setTimeout(close, 2400);
    });

    return; // skip the unreachable legacy code below
  }
  function _legacy_writereview_unused() {
    const trigger = document.getElementById('form-modal');
    const modal   = document.getElementById('modal-container');
    if (!trigger || !modal) return;
    const closeBtn = modal.querySelector('.form-button--close');
    const stars    = modal.querySelectorAll('.score-select-star');
    const form     = modal.querySelector('#form-container');
    const nameI    = modal.querySelector('#name');
    const titleI   = modal.querySelector('#title');
    const bodyI    = modal.querySelector('textarea, #review, #message, #body');

    const filledStar = stars[0] ? stars[0].src.replace('empty-star', 'filled-star') : '';
    const emptyStar  = stars[0] ? stars[0].src : '';
    let chosenStars = 5;

    function openModal() {
      modal.style.cssText = '';
      modal.style.display = 'flex';
      modal.style.position = 'fixed';
      modal.style.inset = '0';
      modal.style.background = 'rgba(0,0,0,0.55)';
      modal.style.zIndex = '9999';
      modal.style.alignItems = 'center';
      modal.style.justifyContent = 'center';
      modal.style.padding = '20px';
      modal.style.visibility = 'visible';
      modal.style.opacity = '1';
      modal.style.pointerEvents = 'auto';
      modal.removeAttribute('data-editor-hidden-popup');
      // make the inner form a card
      if (form) {
        form.style.background = '#fff';
        form.style.borderRadius = '14px';
        form.style.maxWidth = '520px';
        form.style.width = '100%';
        form.style.maxHeight = '90vh';
        form.style.overflowY = 'auto';
        form.style.padding = '28px 24px';
        form.style.position = 'relative';
      }
    }
    function closeModal() {
      modal.style.display = 'none';
    }
    trigger.addEventListener('click', e => { e.preventDefault(); openModal(); });
    closeBtn && closeBtn.addEventListener('click', e => { e.preventDefault(); closeModal(); });
    modal.addEventListener('click', e => { if (e.target === modal) closeModal(); });

    // Star picker
    stars.forEach((s, idx) => {
      s.style.cursor = 'pointer';
      s.addEventListener('click', () => {
        chosenStars = idx + 1;
        stars.forEach((ss, i) => {
          ss.src = i <= idx ? (filledStar || ss.src) : emptyStar;
        });
      });
    });

    // Submit handler — prepend new review at the top of #reviews-list using same template
    if (form) {
      form.addEventListener('submit', e => {
        e.preventDefault();
        const name  = (nameI && nameI.value.trim())  || 'Anonymous';
        const title = (titleI && titleI.value.trim()) || '(no title)';
        const body  = (bodyI && bodyI.value.trim())   || '';

        const listContainer = document.querySelector('#reviews-list .reviews__list');
        const tmpl = listContainer && listContainer.querySelector('.review-card');
        if (listContainer && tmpl) {
          const r = {
            name: name,
            location: 'Just now',
            age: 33,
            date: new Date().toISOString(),
            stars: chosenStars,
            title: title,
            body: body
          };
          const newCard = buildReviewCard(tmpl, r);
          // override avatar with a friendly placeholder (initials block)
          const av = newCard.querySelector('.review-avatar__image img');
          if (av) {
            const initials = name.split(/\s+/).map(w => w[0]).join('').slice(0, 2).toUpperCase();
            av.src = `data:image/svg+xml;utf8,${encodeURIComponent(
              `<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120'><rect width='120' height='120' fill='#e10027'/><text x='60' y='72' font-family='Arial' font-size='44' fill='#fff' text-anchor='middle' font-weight='700'>${initials}</text></svg>`
            )}`;
            av.onerror = null;
          }
          listContainer.insertBefore(newCard, listContainer.firstChild);
        }
        // reset form + close
        if (nameI) nameI.value = '';
        if (titleI) titleI.value = '';
        if (bodyI) bodyI.value = '';
        closeModal();
        // Toast
        const toast = document.createElement('div');
        toast.textContent = 'Thanks! Your review has been posted.';
        toast.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#159201;color:#fff;padding:12px 20px;border-radius:8px;font-weight:600;z-index:99999;box-shadow:0 4px 18px rgba(0,0,0,0.2)';
        document.body.appendChild(toast);
        setTimeout(() => toast.remove(), 3500);
      });
    }
  }

  /* -------- 5. Final CTA relabel -------- */
  function relabelFinalCta() {
    const candidates = document.querySelectorAll(
      'a.cta.cta--regular, a.floating-cta__cta, a.cta-scroll-to-buybox'
    );
    if (!candidates.length) return;
    const last = candidates[candidates.length - 1];
    // Product-aware CTA wording — pulled from the page's product name
    const productName = (() => {
      const titleEl = document.querySelector('h1, .hero-text--heading');
      const title = titleEl ? titleEl.textContent : '';
      if (/so\s*tight/i.test(title) || /so\s*tight/i.test(location.href)) return 'GET SO TIGHT';
      if (/turbo\s*bj/i.test(title) || /turbo[_-]bj/i.test(location.href)) return 'GET TURBO BJ';
      return 'GET YOURS NOW';
    })();
    if (last) last.textContent = productName;

    document.querySelectorAll('.coupon a, .coupon button').forEach(el => {
      const t = (el.textContent || '').trim().toUpperCase();
      if (t === 'ORDER NOW' || t === 'BUY NOW' || t === 'GET 30% OFF TODAY') {
        el.textContent = productName;
      }
    });
  }
})();
